export default __webpack_public_path__ + "static/media/330_dummy2016-naeherin01-de.abfc1c2a.png";